import type { Application as ApplicationModel } from '@/adapters/catalogv1.g';

export function extractApplication(model: ApplicationModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.application_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogApplication = ReturnType<typeof extractApplication>;
